import { memoizeCappedWith } from '~/utils/memoizeUtil';

export default memoizeCappedWith((text) => {
  try {
    const result = JSON.parse(text);
    return typeof result === 'object';
  } catch (e) {
    return false;
  }
});
